export default "__VITE_ASSET__TdnVtB7d__"